<template>
  <Container type="card-full">
    <div slot="header">
      <el-button  @click="saveRfield">保存</el-button>
      <el-button  @click="sortRfield">重新排序</el-button>
      <el-button  @click="showsql">{{btnTitle}}</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <el-form :model="report" ref="form" label-position="left" label-width="100px">
      <el-form-item label="完整sql" v-if="reportsql">
        <el-input v-model="reportsql" :maxlength="1024" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="过滤条件">
        <el-input v-model="report.reportwhere" :maxlength="1024" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <vggrid ref="xGrid" :list="list" tableheight="500" flexname="rfieldflex"
            :cols="cols" :showfooter="false" :showPage="false" :resizable="true"
            :needSelection="true"
            :needRowNum="false"
            :canbeEdit="true"
            @cellClick="cellClick">
    </vggrid>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: 'rfieldForm',
    data () {
      return {
        list: [],
        btnFlg: true,
        btnTitle: '显示SQL',
        report: this.$route.params.form,
        reportsql: '',
        cols: [
          { type:  'checkbox',fieldtype: 'C', title: '选择', calculExpr:'',width: 80 },
          { field: 'seq', title: '序号',calculExpr:'', addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'rfieldcode', title: '列名',calculExpr:'',addNewRowFlg: false},
          { field: 'rfieldname', title: '列说明',calculExpr:'',addNewRowFlg: false},
          { field: 'rfieldsortflg', title: '排序',calculExpr:'',addNewRowFlg: false,syscode: 'rfieldsortflg',editRender: { name: 'select', options: []}}
        ],
        form: {},
        loading: true
      }
    },
    created () {
    },
    activated() {
      this.report = this.$route.params.form
      this.btnTitle = '显示SQL'
      this.reportsql = ''
      this.btnFlg = true
      this.getRfieldList()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      async showsql() {
        if (this.btnFlg) {
          this.btnFlg = false
          this.btnTitle = '隐藏SQL'
          this.reportsql = this.report.reportselect + this.report.reportfrom + ' ' + this.report.reportwhere + this.report.reportorderby
        } else {
          this.btnTitle = '显示SQL'
          this.btnFlg = true
          this.reportsql = ''
        }
      },
      async sortRfield () {
        let model = {
          rfields:this.list,
          reportid: this.report.reportid,
          dsid: this.report.reportdsid,
          reportwhere: this.report.reportwhere
        }
        let data = await request({
          url: '/xtgl/report/sortRfield',
          method: "post",
          data: model
        })
        if (data.issuccess === 1) {
          this.getRfieldList()
          this.$message.success('排序成功！')
        } else {
          this.$message.error('排序失败！')
        }
      },
      async saveRfield () {
        let model = {
          rfields:this.$refs.xGrid.$refs.xGrid.getSelectRecords(),
          reportid: this.report.reportid,
          dsid: this.report.reportdsid,
          reportwhere: this.report.reportwhere
        }
        await request({
          url: '/xtgl/report/saveRfield',
          method: "post",
          data: model
        })
        this.$message.success('操作成功')
        await this.getRfieldList()
      },
      async cellClick (row) {
        this.form = row.row
      },
      async pagechange (fcPage) {
        this.query.currPage = fcPage.currentPage
        this.query.pageSize = fcPage.pageSize
        this.getRfieldList()
      },
      async getRfieldList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/report/getRfieldPageListByReportid',
          params: {reportid: this.report.reportid,dsid: this.report.reportdsid}
        })
        this.list = res
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'reportIndex'})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
</style>
